import { render, staticRenderFns } from "./activityCourseFeedback.html?vue&type=template&id=4631b1ee&scoped=true&external"
import script from "./activityCourseFeedback.vue?vue&type=script&lang=js"
export * from "./activityCourseFeedback.vue?vue&type=script&lang=js"
import style0 from "./activityCourseFeedback.css?vue&type=style&index=0&id=4631b1ee&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4631b1ee",
  null
  
)

export default component.exports